<template>
	<div class="html-content-wrapper" style="height: 500px; overflow: scroll;">
		<iframe ref="iframe" class="content-iframe" frameborder="0"></iframe>
	</div>
</template>

<script>
export default {
	name: 'HtmlRenderer',
	props: {
		content: {
			type: String,
			required: true
		}
	},
	watch: {
		content: {
			immediate: true,
			handler(newContent) {
				this.$nextTick(() => {
					this.updateIframeContent();
				});
			}
		}
	},
	mounted() {
		this.updateIframeContent();
	},
	methods: {
		updateIframeContent() {
			if (!this.$refs.iframe) return;

			const iframe = this.$refs.iframe;
			const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

			// Clear the iframe content
			iframeDoc.open();

			// Write the new content with a base HTML structure
			iframeDoc.write(this.content);

			iframeDoc.close();
		}
	}
};
</script>

<style scoped>
.html-content-wrapper {
	position: relative;
}

.content-iframe {
	width: 100%;
	height: 100%;
	border: none;
	background-color: white;
}
</style>
